<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row" *ngIf="currentTransformation && currentTransformation.status === 2">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-1">
            <div class="card-title">
              <span [data-feather]="'alert-triangle'" class="text-danger" size="18"></span>
              <span class="mt-075 ml-05">{{ "BARGAINING" | translate }} {{ "CANCELED_FEMALE" | translate | lowercase }}</span>
            </div>
          </div>
          <div class="card-body">
            <p class="mb-3">{{ currentTransformation.status_note }}</p>
            <button class="btn btn-outline-success" (click)="restoreTransformation()">{{ "ENABLE" | translate }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="transformationCandidate">
      <section class="col-12" id="page-accordion">
        <div class="card" *ngIf="transformationCandidate">
          <div class="card-title pt-2 px-2 mb-0">
            <h4 class="mb-0">{{ "DETAIL_COLLABORATOR" | translate }}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12" *ngIf="transformationCandidate.firstname">
                <label class="font-small-4 font-weight-bold">{{ "FIRSTNAME" | translate }}:</label>
                <p class="font-medium-1">{{ transformationCandidate.firstname }}</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="transformationCandidate.lastname">
                <label class="font-small-4 font-weight-bold">{{ "LASTNAME" | translate }}:</label>
                <p class="font-medium-1">{{ transformationCandidate.lastname }}</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="transformationCandidate.business_name">
                <label class="font-small-4 font-weight-bold">{{ "BUSINESS_NAME" | translate }}:</label>
                <p class="font-medium-1">{{ transformationCandidate.business_name }}</p>
              </div>
              <div class="col-md-4 col-12">
                <label class="font-small-4 font-weight-bold">{{ "TYPE" | translate }}:</label>
                <p class="font-medium-1">{{ (transformationCandidate.type_code === "stage" ? "INTERN" : transformationCandidate.type_code === "occasional" ? "OCCASIONAL_PERFORMANCE" : "VAT_NUMBER") | translate }}</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="transformationCandidate?.contract?.total_daily">
                <label class="font-small-4 font-weight-bold">{{ "DAILY_COST_PRESUMED" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(transformationCandidate?.contract?.total_daily || 0) }} €</p>
              </div>
              <div class="col-md-4 col-12" *ngIf="transformationCandidate.birthday">
                <label class="font-small-4 font-weight-bold">{{ "APPRENTICEABLE" | translate }}:</label>
                <p class="font-medium-1 text-{{ transformationCandidate.apprenticeship >= 30 ? 'danger' : 'success' }}">{{ transformationCandidate.apprenticeship >= 30 ? ("NO" | translate) : ("YES" | translate) }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="row mb-2" *ngIf="currentTransformation && (currentTransformation.transformation_contract?.status === 3 || currentTransformation.transformation_document?.status === 3 )">
      <div class="col-12 ">
        <div class="card">
          <div class="card-title pt-2 px-2 mb-0">
            <h4 class="mb-0">{{ 'DOCUMENTATION' | translate }}</h4>
          </div>
          <div class="card-body">
            <button class="btn btn-outline-primary mr-md-1" ngClass.sm="my-1" *ngIf="!!currentTransformation.transformation_document.document_url" (click)="_utilService.getFile(currentTransformation.transformation_document.document_url)">{{ "DOCUMENT_ID" | translate }}</button>
            <button class="btn btn-outline-primary mr-md-1" ngClass.sm="my-1" *ngIf="!!currentTransformation.transformation_document.fiscalcode_url" (click)="_utilService.getFile(currentTransformation.transformation_document.fiscalcode_url)">{{ "FISCAL_CODE" | translate }}</button>
            <button class="btn btn-outline-primary mr-md-1" ngClass.sm="my-1" *ngIf="!!currentTransformation.transformation_document.residence_permit_url" (click)="_utilService.getFile(currentTransformation.transformation_document.residence_permit_url)">{{ "RESIDENCE_PERMIT" | translate }}</button>
            <button class="btn btn-outline-primary mr-md-1" ngClass.sm="my-1" *ngIf="!!currentTransformation.transformation_contract.contract_url" (click)="_utilService.getFile(currentTransformation.transformation_contract.contract_url)">{{ "CONTRACT" | translate }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-2" *ngIf="currentTransformation && !candidateBecameEmployee; else bargaingComplete">
      <div class="col-12 d-flex justify-content-center" ngClass.sm="flex-column" ngClass.md="flex-column" cdkDropListGroup>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center">{{ "BARGAINING_STEP.BARGAINING" | translate }}</h4>
          <div cdkDropList class="list-container" id="step0" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-primary" cdkDrag>
              <span class="font-small-4 font-weight-normal" *ngIf="currentTransformation.timeline_status === 0">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center" [ngbTooltip]="currentTransformation.timeline_status === 1 ? ('SEND_MASTERDATA_INFO' | translate) : null">
            {{ "BARGAINING_STEP.SEND_MASTERDATA" | translate }}
          </h4>
          <div cdkDropList class="list-container" id="step1" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-info" cdkDrag *ngIf="currentTransformation.timeline_status === 1 && currentTransformation.transformation_document.status === 1">
              <span (dblclick)="resendMasterData()" class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
            <div
              class="cursor-move badge badge-danger"
              cdkDrag
              [ngbTooltip]="('REFUSE_MOTIVATION' | translate) + ': ' + currentTransformation.transformation_document.status_note"
              *ngIf="currentTransformation.timeline_status === 1 && currentTransformation.transformation_document.status === 4"
            >
              <span (dblclick)="resendMasterData()" class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center">{{ "BARGAINING_STEP.APPROVE_MASTERDATA" | translate }}</h4>
          <div cdkDropList class="list-container" id="step2" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-warning" cdkDrag [ngbTooltip]="'VIEW_DATA' | translate">
              <span (click)="openModal(collaboratorModal, null, 'lg')" class="font-small-4 font-weight-normal" *ngIf="currentTransformation.timeline_status === 2">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center">
            {{ "BARGAINING_STEP.SEND_CONTRACT" | translate }}<span *ngIf="currentTransformation.timeline_status === 3" class="ml-1" [ngbTooltip]="'SEND_CONTRACT_INFO' | translate"><i data-feather="info"></i></span>
          </h4>
          <div cdkDropList class="list-container" id="step3" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-info" cdkDrag *ngIf="currentTransformation.timeline_status === 3 && currentTransformation.transformation_contract.status === 1">
              <span class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
            <div
              class="cursor-move badge badge-danger"
              cdkDrag
              [ngbTooltip]="('REFUSE_MOTIVATION' | translate) + ': ' + currentTransformation.transformation_contract.status_note"
              *ngIf="currentTransformation.timeline_status === 3 && currentTransformation.transformation_contract.status === 4"
            >
              <span class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center">{{ "BARGAINING_STEP.APPROVE_CONTRACT" | translate }}</h4>
          <div cdkDropList class="list-container" id="step4" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-warning" [ngbTooltip]="'VIEW_CONTRACT' | translate" cdkDrag *ngIf="currentTransformation.timeline_status === 4">
              <span (click)="_utilService.getFile(currentTransformation.transformation_contract.contract_url)" class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center">{{ "BARGAINING_STEP.OK" | translate }}</h4>
          <div cdkDropList class="list-container" id="step5" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-success" cdkDrag *ngIf="currentTransformation.timeline_status === 5">
              <span class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
        <div class="container-suitable-candidate" ngClass.sm="mb-1" ngClass.md="mb-1">
          <h4 class="text-center">{{ "BARGAINING_STEP.KO" | translate }}</h4>
          <div cdkDropList class="list-container" id="step6" (cdkDropListDropped)="drop($event)">
            <div class="cursor-move badge badge-danger" cdkDrag *ngIf="currentTransformation.timeline_status === 6">
              <span class="font-small-4 font-weight-normal">{{ currentTransformation.user.complete_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #bargaingComplete>
      <div class="card py-1">
        <div class="card-body d-flex justify-content-center align-items-center">
          <i [data-feather]="'info'" size="25" class="mr-50 text-info"></i>
          <h3 class="mb-0">{{ "COLLABORATOR_TRANSFORMED_TO_EMPLOYEE" | translate }}</h3>
        </div>
      </div>
    </ng-template>

    <div class="row">
      <section class="col-12">
        <!-- PROPOSE_CONTRACT_SECTION-->
        <div class="card" *ngIf="currentTransformation && transformationCandidate">
          <div class="card-body">
            <!-- TYPE CONTRACT INFOMRATION-->
            <div class="card-title d-flex justify-content-between align-items-center" ngClass.sm="flex-column">
              <h4 ngClass.sm="mb-075">{{ "PROPOSAL" | translate }}</h4>
              <button type="button" class="btn btn-outline-primary" *ngIf="currentTransformation.timeline_status < 5" (click)="previewContract()">{{ "VIEW_PREVIEW_CONTRACT" | translate }}</button>
            </div>
            <div class="row">
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_id">{{ "CONTRACT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="contract_id"
                  [items]="contractList"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [(ngModel)]="_contractManager.data.contract"
                  (change)="_contractManager.changeContract($event); _contractManager.typeIsIndeterminate ? (_contractManager.data.end_date = null) : ''"
                ></ng-select>
              </div>
              <div class="form-group col-12 col-md-4" *ngIf="_contractManager.typeIsApprendistato">
                <label for="contract_duration">{{ "DURATION" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  id="contract_duration"
                  type="number"
                  min="1"
                  max="3"
                  [defaultValue]="3"
                  class="form-control {{ !_contractManager.contractDuration ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.contractDuration"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="_contractManager.updateData()"
                />
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato ? 4 : 6)" *ngIf="!_contractManager.typeIsStage">
                <label for="contract_level">{{ "LEVEL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  *ngIf="_contractManager.levels_for_select.length > 0"
                  id="contract_level"
                  class="{{ !_contractManager.data.level ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.level"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  (change)="_contractManager.changeLevel(true, false)"
                >
                  <ng-option *ngFor="let lvl of _contractManager.levels_for_select" [value]="lvl">{{ lvl }}</ng-option>
                </ng-select>
                <select *ngIf="_contractManager.levels_for_select.length < 1" disabled class="form-control"></select>
              </div>
              <div class="form-group col-12 col-md-4" *ngIf="_contractManager.typeIsApprendistato || _contractManager.typeIsStage">
                <label for="contract_level">{{ "TUTOR" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_contractManager.data.tutor_hash" class="{{ !_contractManager.data.tutor_hash ? 'is-invalid' : '' }}">
                  <ng-option *ngFor="let tutor of _contractManager.tutors" [value]="tutor.hash">{{ tutor.firstname }} {{ tutor.lastname }}</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="contract_trial">{{ "CONTRACT_TRIAL_DAYS" | translate }}<sup class="text-danger">*</sup></label>
                <input readonly type="number" id="contract_trial" class="form-control" [(ngModel)]="_contractManager.data.trial" />
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="contract_role">{{ "DUTY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  *ngIf="currentTransformation"
                  bindValue="id"
                  bindLabel="name"
                  id="contract_role"
                  [(ngModel)]="_contractManager.data.role"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  class="{{ !_contractManager.data.role ? 'is-invalid' : '' }}"
                  [virtualScroll]="true"
                  [items]="_userFigureService.list"
                ></ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="contract_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="contract_program"
                  [items]="_contractService.programs"
                  bindLabel="label"
                  bindValue="value"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  class="{{ !_contractManager.data.program ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.program"
                >
                </ng-select>
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  type="date"
                  id="contract_start_date"
                  [min]="today_date"
                  class="form-control {{ !_contractManager.data.start_date ? 'is-invalid' : '' }}"
                  (change)="_contractManager.updateData()"
                  [(ngModel)]="_contractManager.data.start_date"
                />
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger" *ngIf="this._contractManager.data.contract !== 1">*</sup></label>
                <input
                  type="date"
                  id="contract_end_date"
                  [min]="today_date"
                  [readOnly]="_contractManager.typeIsIndeterminate || _contractManager.typeIsApprendistato"
                  (change)="_contractManager.updateData()"
                  class="form-control {{ !_contractManager.data.end_date && !_contractManager.typeIsIndeterminate ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.end_date"
                />
              </div>
            </div>
            <!-- /TYPE CONTRACT INFOMRATION-->

            <!-- COST CONTRACT INFOMRATION-->
            <div class="row">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "EMPLOYEE_COSTS" | translate }}</h4>
              </div>
              <div class="form-group col-12" *ngIf="_contractManager.current_lvl && _contractManager.next_lvl && !_contractManager.typeIsStage">
                <p class="mb-0 font-small-4">
                  <span *ngIf="_contractManager.data.level != 'B3'"
                  >{{ "MINIMUM_RAL_FOR_LEVEL" | translate }}
                    <strong>{{ _utilService.addDotsToNumber(_contractManager.current_lvl.salary_yearly_gross) }}&euro;</strong>
                  </span>
                  <span *ngIf="_contractManager.data.level != 'B3'">
                    | {{ "MAXIMUM_RAL_FOR_LEVEL" | translate }} <strong>{{ _utilService.addDotsToNumber(_contractManager.next_lvl.salary_yearly_gross) }}&euro;</strong></span
                  >
                </p>
                <p class="mb-0 font-small-4" *ngIf="!_contractManager.typeIsApprendistato && _contractManager.data.level === 'B3'">
                  {{ "MINIMUM_RAL_FOR_LEVEL" | translate }}
                  <strong>{{ _utilService.addDotsToNumber(_contractManager.current_lvl.salary_yearly_gross) }}&euro;</strong>
                </p>
                <p class="mb-0 font-small-4" *ngIf="_contractManager.typeIsApprendistato && _contractManager.data.level === 'B3'">
                  {{ "MAXIMUM_RAL_FOR_LEVEL" | translate }}
                  <strong>{{ _utilService.addDotsToNumber(_contractManager.current_lvl.salary_yearly_gross) }}&euro;</strong>
                </p>
              </div>
              <div class="form-group col-md-6 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}<sup class="text-danger">*</sup></label>
                <div class="input-group input-group-merge {{ !_contractManager.data.salary_yearly_gross ? 'is-invalid' : '' }}">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl"
                    type="text"
                    class="form-control bg-white {{ !_contractManager.data.salary_yearly_gross ? 'is-invalid' : '' }}"
                    id="salary_yearly_gross"
                    (change)="transformRal($any($event).target.value)"
                    [(ngModel)]="_contractManager.data.salary_yearly_gross"
                  />
                </div>
              </div>
              <div class="form-group col-md-3 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    type="text"
                    [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl"
                    id="bonus"
                    (change)="_contractManager.updateData('daily_bonus')"
                    class="form-control bg-white"
                    [(ngModel)]="_contractManager.data.bonus"
                  />
                </div>
              </div>
              <div class="form-group col-md-3 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="production_bonus">{{ "PRODUCTION_BONUS" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input
                    type="text"
                    [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl"
                    id="production_bonus"
                    (change)="_contractManager.updateData('production_bonus')"
                    class="form-control bg-white"
                    [(ngModel)]="_contractManager.data.production_bonus"
                  />
                </div>
              </div>
              <div class="col-12"></div>
              <div class="form-group col-md-4 col-12">
                <label for="net_monthly_12">{{ _contractManager.typeIsStage ? ("SALARY_MONTH" | translate) : ("SALARY_MONTH_12" | translate) }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text {{ !_contractManager.typeIsStage ? 'bg-readonly' : '' }}">&euro;</span>
                  </div>
                  <input
                    [readOnly]="!_contractManager.typeIsStage"
                    type="text"
                    id="net_monthly_12"
                    class="form-control"
                    [(ngModel)]="_contractManager.data.net_monthly_12"
                    [value]="_contractManager.data.net_monthly_12"
                    (change)="_contractManager.updateData()"
                  />
                </div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="net_monthly_13">{{ "SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="net_monthly_13" class="form-control" [value]="_contractManager.data.net_monthly_13" />
                </div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="total_monthly_13">{{ "TOTAL_SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="total_monthly_13" class="form-control" [value]="_contractManager.data.total_net_monthly_13" />
                </div>
              </div>
            </div>
            <!-- /COST CONTRACT INFOMRATION-->

            <!-- BONUS TICKET CONTRACT INFOMRATION-->
            <div class="row" *ngIf="!_contractManager.typeIsStage">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "BONUS_TICKET" | translate }}</h4>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_type">{{ "TICKET_TYPE" | translate }}</label>
                <select
                  name="ticket_type"
                  id="ticket_type"
                  class="form-control"
                  [(ngModel)]="_contractManager.data.ticket_type"
                  (change)="_contractManager.data.ticket_month_number = _contractManager.data.ticket_type === 'variabile' ? 20 : 0; _contractManager.updateData()"
                >
                  <option disabled>{{ "TICKET_TYPE" | translate }}</option>
                  <option value="fisso">{{ "STATIC" | translate }}</option>
                  <option value="variabile">{{ "VARIABLE" | translate }}</option>
                </select>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_month_number">{{ "TICKET_MONTH_NUMBER" | translate }}</label>
                <input
                  type="number"
                  (change)="_contractManager.updateData()"
                  class="form-control"
                  [readOnly]="_contractManager.data.ticket_type === 'variabile'"
                  id="ticket_month_number"
                  [(ngModel)]="_contractManager.data.ticket_month_number"
                />
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_value">{{ "TICKET_DAILY_VALUE" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" id="ticket_value" (change)="transformTicketValue($any($event.target))" class="form-control" [(ngModel)]="_contractManager.data.ticket_value" />
                </div>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="total_monthly_13">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" class="form-control" [value]="calculateTicketTotalMonth()" />
                </div>
              </div>
            </div>
            <!-- /BONUS TICKET CONTRACT INFOMRATION-->

            <!-- FOOTER PROPOSE CONTRACT SECTION-->
            <div class="row border-top pt-2 mt-1 align-items-center">
              <div class="col-md-6 col-12 contract-daily-cost">
                {{ "TOTAL_SALARY_DAILY" | translate }}
                <strong>{{ _contractManager.data.total_daily }} &euro;</strong>
              </div>
              <div class="col-md-6 col-12 text-right">
                <button class="btn btn-primary" (click)="edit()" [disabled]="isDisabledSave()" *ngIf="currentTransformation.status === 0 && _authenticationService.hasCapability('edit_transformation')">
                  {{ "SAVE" | translate }}
                </button>
              </div>
            </div>
            <!-- /FOOTER PROPOSE CONTRACT SECTION-->
          </div>
        </div>
        <!-- /PROPOSE_CONTRACT_SECTION-->
      </section>
    </div>
  </div>
</div>

<!-- Note Modal -->
<ng-template #noteModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MOTIVATION_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="note">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea class="form-control" name="note" id="note" cols="45" rows="3" [(ngModel)]="status_note"> </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-outline-primary w-150" rippleEffect (click)="modalClose()">
      {{ "BACK" | translate }}
    </button>
    <button [disabled]="!status_note || status_note.length < 5" (click)="rejectDocument()" class="btn btn-primary w-150" rippleEffect>
      {{ "REJECT" | translate }}
    </button>
  </div>
</ng-template>
<!-- / Note Modal -->

<!-- Candidate Modal -->
<ng-template #collaboratorModal let-modal>
  <div>
    <div class="modal-header">
      <div>
        <h3 class="mb-0">{{ "DETAIL_SINGULAR" | translate }} {{ "TITLES.USERS_TYPES_SINGULAR.candidate" | translate | lowercase }}</h3>
      </div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3 class="mb-075">{{ transformationCandidate.firstname }} {{ transformationCandidate.lastname }}</h3>
      <div class="row">
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "GENDER" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.sex === "m" ? ("MALE" | translate) : transformationCandidate.sex === "f" ? ("FEMALE" | translate) : ("OTHER" | translate) }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "BIRTH_PLACE" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.birth_place_name }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "BIRTHDAY" | translate }}:</label>
          <p class="font-medium-1">{{ _utilService.formatDate(transformationCandidate.birthday, "DD/MM/YYYY") }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "PRIVATE_PHONE" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.phone }}</p>
        </div>
        <div class="col-md-8 col-12">
          <label class="font-small-4">{{ "PRIVATE_EMAIL" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.private_email }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "FISCAL_CODE" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.fiscalcode }}</p>
        </div>
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "NATIONALITY" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.identity_document.nationality }}</p>
        </div>
      </div>
      <h3 class="mb-075 mt-2">{{ "RESIDENCE_ADDRESS" | translate }}</h3>
      <div class="row">
        <div class="col-md-4 col-12">
          <label class="font-small-4">{{ "STREET" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.addresses[0].street }}</p>
        </div>
        <div class="col-md-3 col-12">
          <label class="font-small-4">{{ "ZIPCODE" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.addresses[0].zipcode }}</p>
        </div>
        <div class="col-md-3 col-12">
          <label class="font-small-4">{{ "CITY" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.addresses[0].city_name }}</p>
        </div>
        <div class="col-md-2 col-12">
          <label class="font-small-4">{{ "PROVINCE" | translate }}:</label>
          <p class="font-medium-1">{{ transformationCandidate.addresses[0].province_name }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center" *ngIf="transformationCandidate && transformationCandidate.identity_document">
    <button class="btn btn-outline-primary mr-075" *ngIf="transformationCandidate.identity_document.residence_permit_url" (click)="_utilService.getFile(transformationCandidate.identity_document.residence_permit_url)">
      {{ "VIEW_PERMIT_URL" | translate }}
    </button>
    <button class="btn btn-outline-primary mr-075" *ngIf="transformationCandidate.identity_document.fiscalcode_url" (click)="_utilService.getFile(transformationCandidate.identity_document.fiscalcode_url)">
      {{ "VIEW_FISCAL_CODE_DOCUMENT" | translate }}
    </button>
    <button class="btn btn-outline-primary" (click)="_utilService.getFile(transformationCandidate.identity_document.document_url)">{{ "VIEW_DOCUMENT" | translate }}</button>
  </div>
</ng-template>
<!-- / Candidate Modal -->

<!-- Disable Transformation Modal -->
<ng-template #noteDisableTransformation let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_MOTIVATION_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="rejectedNote2">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="disableNote" class="form-control" name="rejectedNote" id="rejectedNote2" cols="45" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose(true)">{{ "BACK" | translate }}</button>
      <button [disabled]="disableNote.length < 5" (click)="disableTransformation()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / Disable Transformation Modal -->
